/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AdminDefs from './defs.defs.js'

const $nsid = 'com.atproto.admin.getAccountInfos'

export { $nsid }

/** Get details about some accounts. */
const main = l.query(
  $nsid,
  l.params({ dids: l.array(l.string({ format: 'did' })) }),
  l.jsonPayload({
    infos: l.array(
      l.ref<AdminDefs.AccountView>((() => AdminDefs.accountView) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
